/* global $, _, google */

'use strict';

require('bootstrap_css');
require('../css/style.scss');

var otherOfficePin = require('../images/other-office-pin.svg');
var googleMapsPin = require('../images/google-maps-pin.svg');
var poly = require('poly-js-utils');
var qs = require('qs');
var cookies = require('js-cookie');
var browser = require('detect-browser');

var mainNavHtml = require('../templates/main-nav.html');
var mobileNavHtml = require('../templates/mobile-nav.html');
var bioPhotoHtml = require('../templates/bio-photo.html');
var bioHtml = require('../templates/bio.html');
var teamPhotoHtml = require('../templates/team-photo.html');
var teamHtml = require('../templates/team.html');
var officeHtml = require('../templates/our-offices.html');
var officeListTemplate = require('../templates/office-list.html');
var postsHtml = require('../templates/posts.html');
var eventsHtml = require('../templates/events.html');
var aboutNavHtml = require('../templates/about-nav.html');
var aboutTeamHtml = require('../templates/about-team.html');
var lightboxHtml = require('../templates/lightbox.html');
var insuranceHtml = require('../templates/insurance.html');
var languagesHtml = require('../templates/languages.html');
var licensesHtml = require('../templates/licenses.html');
var evergreenHtml = require('../templates/evergreen-content.html');
var communityHTML = require('../templates/community.html');

import { addNavHandlers } from './nav/nav-handlers';
import { setRooftopPosition } from './nav/set-rooftop-position';

var baseLink = poly.JSContext.getBaseLink();
var themeData = poly.JSContext.getThemeData();
var resize = poly.ImageResizing.resize;
var categories = poly.JSContext.getCategories();
var communityInfo = poly.JSContext.getProfile().community;
var profileExpertiseContent = poly.JSContext.getProfile().evergreen_content_items;
var themeExpertiseContent = poly.JSContext.getThemeData().evergreen_content_items;
var expertiseTile = poly.JSContext.getThemeData().evergreen_content_tiles;

// TODO move this to poly?
var JSContext = window.JSContext || {};
var isPreview = JSContext.is_preview;
var groupId = JSContext.group_id;

// initialized in document.ready
var relatePhoneNumber;
var relateAttestationText;
var relateConsentMessage;

var parsedUrl = poly.Utils.parseUrl(location);
var queryParams = qs.parse(parsedUrl.search);

var PHONE_NUMBER_COOKIE_NAME = "BNI_TrackableNumber";
var PHONE_NUMBER_REGEX = /^\d{7}(\d{3,4})?$/;
var KEY_TAB = 9;
var KEY_ESC = 27;

var getAboutPageTab = function() {
    var pageArray = parsedUrl.pathname.split('/');
    var tabs = ['about-me', 'about-the-team', 'contact-us'];

    return _.find(pageArray, function(pathString) {
        return _.find(tabs, function(tab) {
            return tab === pathString;
        });
    });
};

var getProfile = function() {
    var profile = poly.JSContext.getProfile();
    if(profile) {
        poly.Utils.breakParagraphs(profile, 'office_description');
        poly.Utils.breakParagraphs(profile.address, 'landmark');
        poly.Utils.addFormattedPhone(profile.phones, 'phone');
        poly.Utils.addFormattedPhone(profile.phones, 'toll_free');
        poly.Utils.addFormattedPhone(profile.phones, 'fax');
        profile.office_hours_structured ?
            poly.DateTimeHelpers.formatOfficeHours(profile, 'office_hours_structured') :
            poly.Utils.breakParagraphs(profile, 'office_hours');

        _.each(profile.suboffices, function(suboffice) {
            poly.Utils.breakParagraphs(suboffice, 'description');
            poly.Utils.breakParagraphs(suboffice, 'landmark');
            poly.Utils.addFormattedPhone(suboffice, 'phone');
            poly.Utils.addFormattedPhone(suboffice, 'toll_free');
            poly.Utils.addFormattedPhone(suboffice, 'fax');
            suboffice.office_hours_structured ?
                poly.DateTimeHelpers.formatOfficeHours(suboffice, 'office_hours_structured') :
                poly.Utils.breakParagraphs(suboffice, 'hours');
        });

        _.each(profile.team_members, function(member) {
            poly.Utils.addFormattedPhone(member, 'member_phone');
            // Splitting, trimming and rejoining for the sake of uniform whitespace on the website
            if(member.member_licenses) {
                member.licenses = [];
                _.each(member.member_licenses.split(";"), function(license) {
                    if(license) {
                        member.licenses.push(license.trim());
                    }
                });
            }
        });

        // Make a list of states from the licenses list.
        profile.agent_licenses = _.map(profile.licenses, function(license) {
            return license.license_state.split("-")[0].trim();
        });

        // This value is complicated because it's a tag. This is a workaround to make our data nice.
        profile.american_star = poly.Utils.selectBoxIsTrue(profile.amstar_award);

        // Set default values for these insurance types, if none are specified in the profile.
        profile.insurance = profile.insurance || themeData.agent_defaults.insurance;
    }
    return profile;
};

var profile = getProfile();

// Creates a reference array for all suboffices regardless of content
var createOfficeReference = function(suboffices, newProp) {
    var offices = [];
    offices.push(newProp + 0);

    if (suboffices) {
        for (var i = 1, len = suboffices.length; i <= len; i++) {
            const reference = newProp + i;
            suboffices[i - 1].reference = reference;
            offices.push(reference);
        }
    }

    return offices;
};

// Assigns team members to their selected offices
var assignTeamMembers = function(teamMembers, availableOffices, suboffices) {
    var offices = {};

    _.each(teamMembers, function(agent) {
        if (!agent.associated_offices) {
            if (!offices['office_0']) {
                offices['office_0'] = [];
            }

            offices.office_0.push(agent);
        } else {
            _.each(agent.associated_offices, function(officeId) {
                if (_.contains(availableOffices, officeId)) {
                    if (!offices[officeId]) {
                        offices[officeId] = [];
                    }
                    offices[officeId].push(overridePhoneNumbers(agent, officeId, suboffices));
                } else {
                    if (!offices['office_0']) {
                        offices['office_0'] = [];
                    }

                    if (!_.contains(agent.associated_offices, 'office_0')) {
                        offices.office_0.push(agent);
                    }
                }
            });
        }
    });
    return offices;
};

var resizePostContentPreview = function() {
    $('.message-with-title').each(function() {
        if (!$(this).is(':visible')) { return; }

        var $parent = $(this).parent();
        var $headline = $parent && $parent.find('.stories-headline');
        var headlineHeight = $headline && $headline.is(':visible') && $headline.outerHeight();

        if (headlineHeight) {
            var bottomMargin = 45;
            var defaultHeight = 170;
            $(this).height(defaultHeight - headlineHeight - bottomMargin);
        }
    });
};

var overridePhoneNumbers = function(agent, reference, suboffices) {
    let subOffice;
    if (reference === 'office_0') {
        const { phone, fax } = profile.phones;
        subOffice = {
            phone,
            fax
        };
    } else {
        subOffice = findOffice(reference, suboffices);
    }
    if (!subOffice) {
        return agent;
    }

    const newAgent = Object.assign({}, agent);
    const { phone, fax } = subOffice;
    if (phone) {
        newAgent.member_phone = phone;
        newAgent.member_phone_link_formatted = poly.Utils.stripNonDigits(phone);
    }
    if (fax) {
        newAgent.member_fax = fax;
    }
    return newAgent;
};

var findOffice = function(reference, suboffices) {
    return suboffices.filter(office => office.reference === reference)[0];
};

// Merges main office prop & suboffice props into one object
var mergeProps = function(officeProp, suboffices, primarySubProp, secondarySubProp, newObjKey) {
    var collection = {};

    if (officeProp) {
        collection[newObjKey + '0'] = officeProp;
    }

    if (suboffices) {
        for (var i = 1, len = suboffices.length; i <= len; i++) {
            collection[newObjKey + i] = suboffices[i - 1][primarySubProp] ?
                suboffices[i - 1][primarySubProp] :
                suboffices[i - 1][secondarySubProp];
        }
    }

    return collection;
};

var officeReference = createOfficeReference(profile.suboffices, 'office_');
var associatedOffices = assignTeamMembers(profile.team_members, officeReference, profile.suboffices);
var officeImages = mergeProps(profile.team_photo, profile.suboffices, 'team_photo', '', 'office_');
var officeStreets = mergeProps(profile.address.street, profile.suboffices, 'street', 'street', 'office_');

// eslint-disable-next-line
var officeDescriptions = mergeProps(profile.office_description, profile.suboffices, 'team_description', 'description', 'office_');

var getOverridePhone = function(queryParams) {
    var phoneParam = queryParams.phone || queryParams["?phone"];
    if(phoneParam && phoneParam.match(PHONE_NUMBER_REGEX)) {
        // set the cookie and return this parameter if this is a phone number that poly-js-utils can handle
        cookies.set(PHONE_NUMBER_COOKIE_NAME, phoneParam, { expires: 730, domain: '.amfam.com'});
        return phoneParam;
    } else {
        phoneParam = cookies.get(PHONE_NUMBER_COOKIE_NAME);
        if(phoneParam && phoneParam.match(PHONE_NUMBER_REGEX)) {
            return phoneParam;
        }
    }
};

var getOfficeInfo = function(profile) {
    if(!profile) {
        return;
    }
    var offices = [];
    var overridePhone = getOverridePhone(queryParams);
    var latlng = profile.geographical_location &&
        profile.geographical_location.latitude && profile.geographical_location.longitude ?
        [parseFloat(profile.geographical_location.latitude), parseFloat(profile.geographical_location.longitude)] :
        profile.latlng && profile.latlng.map(parseFloat);

    var virtual_office_location = profile.virtual_office_location || {};
    offices.push({
        'id': 'main-office',
        'office_image': profile.office_image,
        'office_image_resize_ready': profile.office_image_resize_ready,
        'office_nickname': profile.office_nickname,
        'street': profile.address.street,
        'suite': profile.address.suite,
        'city': profile.address.city,
        'state': profile.address.state,
        'zip_code': profile.address.zip_code,
        'virtual_location': virtual_office_location.primary_office_virtual_location,
        'hide_image': poly.Utils.selectBoxIsTrue(virtual_office_location.primary_office_hide_image),
        'hide_address': poly.Utils.selectBoxIsTrue(virtual_office_location.primary_office_hide_address),
        'hide_street': poly.Utils.selectBoxIsTrue(virtual_office_location.primary_office_hide_street),
        'landmark_paragraphs': profile.address.landmark_paragraphs,
        'phone': overridePhone || profile.phones.phone,
        'phone_link_formatted': overridePhone || profile.phones.phone_link_formatted,
        'toll_free': profile.phones.toll_free,
        'toll_free_link_formatted': profile.phones.toll_free_link_formatted,
        'fax': profile.phones.fax,
        'fax_link_formatted': profile.phones.fax_link_formatted,
        'description_paragraphs': profile.office_description_paragraphs,
        'latlng': latlng,
        'office_hours': profile.formatted_office_hours_structured ?
            profile.formatted_office_hours_structured :
            profile.office_hours_paragraphs
    });
    _.each(profile.suboffices, function(suboffice, counter) {
        var latlng = suboffice.latitude && suboffice.longitude ?
            [parseFloat(suboffice.latitude), parseFloat(suboffice.longitude)] :
            profile.latlon_fields.suboffices[counter] &&
                profile.latlon_fields.suboffices[counter].split(',').map(parseFloat);

        var office = _.extend(suboffice, {
            'id': 'other-office-' + counter,
            'latlng': latlng,
            'phone': overridePhone || suboffice.phone,
            'phone_link_formatted': overridePhone || suboffice.phone_link_formatted,
            'office_hours': suboffice.formatted_office_hours_structured ?
                suboffice.formatted_office_hours_structured :
                suboffice.hours_paragraphs,
            'hide_image': poly.Utils.selectBoxIsTrue(suboffice.hide_image),
            'hide_address': poly.Utils.selectBoxIsTrue(suboffice.hide_address),
            'hide_street': poly.Utils.selectBoxIsTrue(suboffice.hide_street)
        });
        offices.push(office);
    });
    return offices;
};
var allOffices = getOfficeInfo(profile);
// Apparently, templates are initialized when you call append() on a selector that doesn't find anything.
// That causes unanticipated errors and it's probably a little wasteful.
var appendTemplateIfParentExists = function(selector, html, args) {
    var element = $(selector);
    if(element.length) {
        var template = _.template(html);
        element.append(template(args));
    }
};

// Resets the mobile nav position to it's default state
var resetNavPosition = function() {
    var width = $(window).width();
    $('#mobile-nav .nav-list').css('left', 0);
    $('#mobile-nav .inner-list').css({
        left: width,
        display: 'none'
    });
};

// Insurance nav should have 6 items
// If agent only selected 3, concat first 3 from the gloabl insurance list
var concatRemainingInsurance = function(profileInsurance, insurance) {
    var fillerLength = 6 - profileInsurance.length;
    return profileInsurance.concat(insurance.slice(0, fillerLength));
};

var setUpNav = function(baseLink, themeData) {
    var insurance = getInsurance();
    insurance = concatRemainingInsurance(insurance.profileInsurance, insurance.insurance);
    var width = $(window).width();
    var contactText = themeData.global_nav_contact_text || "Contact";

    appendTemplateIfParentExists(
        '#main-nav',
        mainNavHtml,
        {
            baseLink: baseLink,
            insurance: insurance,
            categories: categories,
            currentPage : currentPage,
            accountNav: themeData.account_nav_items,
            contactText: contactText
        }
    );

    appendTemplateIfParentExists(
        '#mobile-nav',
        mobileNavHtml,
        {
            baseLink: baseLink,
            themeData: themeData,
            currentPage: currentPage,
            insurance: insurance,
            categories: categories,
            accountNav: themeData.account_nav_items,
            contactText: contactText
        }
    );

    $('#mobile-nav .inner-list').css('left', width);

    var $mobileMenuButton = $('.mobile-menu-button');

    var closeMobileMenu = function() {
        $mobileMenuButton.toggleClass('open');
        $mobileMenuButton.toggleClass('icon-menu icon-exit');
        $('#amfam-nav').toggleClass('open');
        $('#mobile-nav').toggle(0, function() {
            if(!$('.mobile-menu-button').hasClass('open')) {
                resetNavPosition();
            }
        });
    };

    // OnClick hide/show the mobile menu and change the anchor text accordingly.
    $mobileMenuButton.click(function(e) {
        e.preventDefault();
        closeMobileMenu();
    });

    // On click of nav list, show sub nav and slide the main nav out
    $('.nav-list__item.has-inner').click(function() {
        var id = $(this).attr('id');
        var subList = '#' + id + '-inner';
        $(subList).css('display', 'block');
        $('.nav-list, ' + subList).animate({
            left: '-=' + width
        }, 500);
    });

    // On click of back button, hide subnav and slide main nav in
    $('.inner-list__item .back').click(function() {
        var parentId = '#' + $(this).parents('.inner-list').attr('id');
        $('.nav-list, ' + parentId).animate({
            left: '+=' + width
        }, 500, function() {
            $(parentId).css('display', 'none');
        });
    });

    $('.contact-link > a').click(closeMobileMenu);

    var aboutPageTab = getAboutPageTab();

    appendTemplateIfParentExists(
        '#about-nav',
        aboutNavHtml,
        {
            baseLink: baseLink,
            page: aboutPageTab
        }
    );
};

// Centers subnavs under their nav titles
var setNavDropdownPosition = function() {
    $('#main-nav .nav-list__item').each(function() {
        var navItem = $(this);
        var subNav = navItem.find('.inner-list');
        if(subNav.length) {
            var navItemWidth = navItem.width();
            var subNavWidth = subNav.width();
            var subNavShift = (subNavWidth / 2) - (navItemWidth / 2);
            subNav.css('right', -subNavShift);
        }
    });
};

// example params: zipCode=53783&origin=agentWebSite&gname=Jericks1&action=Estimate&qrfAgent=Joshua_Erickson_WI_JEricks1&vendor=Hearsay
var buildQuoteLink = function(themeData, profile, zipCode) {
    var agentString = profile.first_name + "_" + profile.last_name + "_" + profile.address.state + "_" + profile.gname;

    return themeData.corp_header_link_1 +
        "&gname=" + profile.gname +
        "&qrfAgent=" + agentString +
        "&zipCode=" + zipCode;
};

var getUserLocation = function() {
    if(navigator.geolocation && (typeof google === 'object' && typeof google.maps === 'object')) {
        navigator.geolocation.getCurrentPosition(function(position) {
            $('body').removeClass('geolocation-service-blocked');
            var geocoder = new google.maps.Geocoder;
            geocoder.geocode({'location': {lat: position.coords.latitude, lng: position.coords.longitude}},
                function(results, status) {
                    if (status === 'OK' && results[0]) {
                        var zip_code = _.find(results[0].address_components, function(component) {
                            return component.types[0] === "postal_code";
                        });
                        $('#quote-zip_code').val(zip_code.short_name);
                    }
                }
            );
        }, function(error) {
            if (error.code === error.PERMISSION_DENIED) {
                $('body').addClass('geolocation-service-blocked');
            }
        });
    }
};

var addQuoteHandlers = function() {
    var $quoteForms = $('.quote-form');

    $quoteForms.each(function(i, quoteFormElement) {
        var $quoteForm = $(quoteFormElement);
        var input = $quoteForm.find('.quote-zip_code');
        var formContainer = $quoteForm.find('.quote-container');
        var pinIcon = $quoteForm.find('.icon-find');
        var submitButton = $quoteForm.find('.quote-form-submit');

        var bioButtons = $('.agent-bio-buttons > a, .agent-bio-buttons > button');
        var closeButton = $quoteForm.find('.quote-form-close');

        var populateInput = function() {
            if (!input.val()) {
                getUserLocation();
            }
        };

        var styleValidation = function() {
            if ($quoteForm.hasClass('validated')) {
                if (input.is(":valid")) {
                    formContainer.removeClass('has-invalid');
                    input.attr('placeholder', 'ZIP Code');
                } else {
                    formContainer.addClass('has-invalid');
                    input.attr('placeholder', 'ZIP required');
                }
            }
        };

        // Support old get quote buttons
        var closeQuoteForm = function($quoteForm) {
            formContainer.removeClass('has-invalid');
            closeButton.removeClass('shown');
            input[0].value = "";
            input.unbind('keyup', styleValidation);
            input.attr('placeholder', 'ZIP Code');
            $quoteForm.removeClass('open');
            $quoteForm.removeClass('validated');
            bioButtons.css('visibility', 'visible');
        };

        // Handler to close the quote widget when the close button is clicked
        if (closeButton && bioButtons) {
            closeButton.on('click', function() {
                closeQuoteForm($quoteForm);
            });

            // Open the quote widget when the quote link is clicked
            $('#quote-link').on('click', function(e) {
                e.preventDefault();
                bioButtons.css('visibility', 'hidden');
                $quoteForm.addClass('open');
                closeButton.addClass('shown');
                input.focus();
                populateInput();
            });
        }

        // Handler to repopulate input when the map pin icon is clicked
        pinIcon.on('click', populateInput);

        submitButton.on("click", function(e) {
            e.preventDefault();

            // add html5 validation errors, if any
            $quoteForm[0].checkValidity();
            $quoteForm.addClass('validated');

            if (input.is(":invalid")) {
                formContainer.addClass('has-invalid');
                input.attr('placeholder', 'ZIP required');
                input.keyup(styleValidation);
                return false;
            }

            else { // get the quote page
                window.open(buildQuoteLink(themeData, profile, input[0].value));
                closeQuoteForm($quoteForm);
            }
        });
    });
};

var renderTeamPhoto = function(profile, resize) {
    if(profile && profile.profile_photo) {
        appendTemplateIfParentExists(
            '#team-photo',
            teamPhotoHtml,
            {
                profile: profile,
                resize: resize
            }
        );
    }
};

var renderBioPhoto = function(profile, resize) {
    if(profile && profile.profile_photo) {
        appendTemplateIfParentExists(
            '#bio-photo',
            bioPhotoHtml,
            {
                profile: profile,
                resize: resize
            }
        );
    }
};

var renderAgencyRatings = function(rating) {
    var parsedRating = parseFloat(rating);

    if (parsedRating <= 5 && parsedRating >= 0) {
        $('.agency-ratings').removeClass('hidden');
        $('.rating.icon-star').slice(Math.round(parsedRating)).addClass('icon-star-empty');
    } else {
        $('.agency-ratings').remove();
    }
};

var renderLanguages = function(languages) {
    var languageList = [];

    _.map(languages, function(language) {
        var current = poly.ViewHelpers.getTagDisplayValue('amfam_languages', language);

        if (current) {
            languageList.push(current);
        }
    });

    appendTemplateIfParentExists(
        '#languages',
        languagesHtml,
        {languages: languageList.join(", ")}
    );
};

var renderLicenses = function(agentLicenses) {
    const licenses = agentLicenses.join(', ');
    appendTemplateIfParentExists(
        '#licenses',
        licensesHtml,
        { licenses }
    );
};

var renderTeam = function(baseLink, themeData, profile) {
    const getSocialUrlVals = (val, key) => key.indexOf('_url') > -1 && Boolean(val);
    const socialLinks = _.pick(profile.networks || {}, getSocialUrlVals);

    //GTM social `data-network-name` attr. value is case sensitive
    const gtmSocialNetworkNames = {
        facebook_url: "Facebook",
        twitter_url: "Twitter",
        linkedin_url: "LinkedIn",
        googleplus_url: "Google",
        instagram_url: "Instagram"
    };
    appendTemplateIfParentExists(
        '#team',
        teamHtml,
        {
            baseLink,
            profile,
            socialLinks,
            gtmSocialNetworkNames,
            themeData
        }
    );

    // Handler to open American Star Modal
    $('.american-star-logo img').on('click', function() {
        $('#americanStarModal').modal('show');
    });
};

var renderBio = function(baseLink, themeData, profile) {
    const getSocialUrlVals = (val, key) => key.indexOf('_url') > -1 && Boolean(val);
    const socialLinks = _.pick(profile.networks || {}, getSocialUrlVals);

    //GTM social `data-network-name` attr. value is case sensitive
    const gtmSocialNetworkNames = {
        facebook_url: "Facebook",
        twitter_url: "Twitter",
        linkedin_url: "LinkedIn",
        googleplus_url: "Google",
        instagram_url: "Instagram"
    };
    appendTemplateIfParentExists(
        '#bio',
        bioHtml,
        {
            baseLink,
            profile,
            socialLinks,
            gtmSocialNetworkNames,
            themeData
        }
    );

    addQuoteHandlers();

    // Handler to open American Star Modal
    $('.american-star-logo img').on('click', function() {
        $('#americanStarModal').modal('show');
    });
};
// ex: virtualURLBaseLinkHelper(window.location, baseLink) ->
// '/ca/san+francisco/batman+building'
var virtualURLBaseLinkHelper = function(location, baseLink) {
    return location.href.split(baseLink)[1];
};

//  ex: officeStringHelper('San Francisco') -> 'san+francisco'
var officeStringHelper = function(s) {
    return s.trim().toLowerCase().replace(/\s/g, "-").replace(/#/g, "");
};

// ex: getOfficePat(office) -> '/ca/san+francisco/batman+building'
var getOfficePath = function(office) {
    var state = officeStringHelper(office.state);
    var city = officeStringHelper(office.city);
    var street = officeStringHelper(office.street);
    return state + '/' + city + '/' + street + '/';
};

// static pages - used to remove from the path for our lookup obj
// eslint-disable-next-line
var staticPages = ["about-me", "about-the-team", "contact-us", "events", "insurance", "stories-and-articles"];
var nonLocationPages = ["about-me", "events", "insurance", "stories-and-articles"];

var getOfficeFromURL = function(path) {
    // Grab all offices, make sure we can compare states in lowercase.
    var offices = _.each(_.map(allOffices, _.clone), function(office) {
        office.state = officeStringHelper(office.state);
    });

    if(!path) { return offices[0]; }
    // Remove preceding and trailing slashes.
    var endPoints = path.split('/');
    if(endPoints[0] === "") { endPoints.shift(); }
    if(endPoints[endPoints.length - 1] === "") { endPoints.pop(); }

    // Remove static pages
    var officeIdentifiers = _.difference(endPoints, staticPages);

    // If no identifiers at this point, return the default office.
    if(!officeIdentifiers.length) { return offices[0]; }

    // Create an object with the identifiers
    var officeLookup = _.object(["state", "city", "street"], officeIdentifiers);

    // Check if `/state/` matches office in list
    var stateOffices = _.where(offices, { 'state': officeLookup.state.toLowerCase() });

    // Fall through if no state match found
    if (!stateOffices.length) {
        return offices[0];
    } else if (!officeLookup.city && stateOffices.length) {
        // no city to lookup, grab first matched state.
        return stateOffices[0];
    }

    //check if `/city/` is in the new state matched list
    if (officeLookup.city) {
        _.each(stateOffices, function(office) { office.city = officeStringHelper(office.city); });
        var cityOffices = _.where(stateOffices, { 'city': officeLookup.city });

        // return the first state matched office
        if(!cityOffices.length) { return stateOffices[0]; }

        // no nickname - return the first city matched office
        if (!officeLookup.street && cityOffices) {
            return cityOffices[0];
        } else {
            _.each(cityOffices, function(office) { office.street = officeStringHelper(office.street); });
            var streetOffice = _.findWhere(cityOffices, { 'street': officeLookup.street });
            return streetOffice || offices[0];
        }
    } else {

        // fall through to the default first office if no state match found.
        return stateOffices ? stateOffices[0] : offices[0];
    }
};

var updateCookieForLocation = function(path) {
    /**
    * Get the correct path from an office found in the URL
    * If our data has been updated, we want to call getOfficeFromURL(path)
    * Which will return a default if the URL associated office is no longer present.
    * when testing locally, you will need to change options to { expires: 730, domain: 'localhost' }
    */
    var validPathOrDefault = getOfficePath(getOfficeFromURL(path));
    cookies.set('agencyLocation', validPathOrDefault, { expires: 730, domain: '.amfam.com' });
};

var updateNavLinksForLocation = function(path) {

    // Class used for location aware page navigation links
    var navLinks = $('.location-link');

    // Update location aware navigation links - account for anchor links
    _.each(navLinks, function(link) {

        // remove extra slashes from our hashes
        link.hash = link.hash.replace(/\//g, '');

        // construct location links for location aware pages
        if(link.pathname.split('/').indexOf("about-the-team") > 0) {
            link.href = baseLink + path.slice(0, -1) + "/about-the-team" + link.hash + '/';
        } else if(link.pathname.split('/').indexOf("contact-us") > 0) {
            link.href = baseLink + path.slice(0, -1) + "/contact-us" + link.hash + '/';
        } else {
            link.href = baseLink + path.slice(0, -1) + link.hash + '/';
        }
    });
};

var setOfficeLocation = function(path) {
    var staticPage = _.intersection(staticPages, window.location.pathname.split('/'));
    var nonLocationPage = _.intersection(staticPage, nonLocationPages);
    var hash = window.location.hash;
    var querystring = window.location.search;
    var page = staticPage.length ? staticPage + '/' : "";
    var location = baseLink + (nonLocationPage.length ? "" : path) + page + querystring + hash;
    history.replaceState({ selectedOffice: path }, "agencyLocation", location);
};

var checkStaticEndpoint = function(pages) {
    var staticPage = _.intersection(pages, window.location.pathname.split('/'));
    return staticPage[0];
};

var currentPage = checkStaticEndpoint(staticPages);

var onLocationSelected = function(path) {
    setOfficeLocation(path);
    updateNavLinksForLocation(path);
    updateCookieForLocation(path);
};

var onLocationUnawarePageLoad = function() {
    var agencyLocation = cookies.get('agencyLocation');
    var office = allOffices[0];
    var defaultPath = getOfficePath(office);
    if(agencyLocation) {

        // check here to see if our cookie still exists in data
        // if it does not, getOfficeFromURL will return default office
        var urlOfficeOrDefault = getOfficeFromURL(agencyLocation);
        var path = getOfficePath(urlOfficeOrDefault);
        onLocationAwarePageLoad(path);
    } else {
        onLocationAwarePageLoad(defaultPath);
    }
};

var selectedOfficeId;
var officeMarkers = {};
var officeSelectedIcons = {};
var nonSelectedMarkerIcon;
var selectedMarkerIcon;

var onLocationAwarePageLoad = function(path) {
    var office = getOfficeFromURL(path);

    var officePath = getOfficePath(office);
    var dataLocation = $('a[data-location="' + office.street + '"]')[0];
    selectedOfficeId = office.id;

    if(dataLocation) {
        var officeTab = $('a[data-location="' + office.street + '"]')[0].getAttribute('data-office');
        var officeTabContent = $('.office-identifier[data-office="' + officeTab + '"]');

        // remove the previously active tab
        $('.office-link.active').removeClass('active');

        // add active to the URL based location
        $(dataLocation.parentElement).addClass('active');

        // show office tab content for URL location
        officeTabContent.removeClass('hidden').addClass('active');
    }
    setOfficeLocation(officePath);
    updateNavLinksForLocation(officePath);
    updateCookieForLocation(officePath);
};

// the url parameter for the correct tab to show on load looks like location='Url%20Encoded%20Street%20Address'
var getOfficeIdForLocationQuery = function(location, offices) {
    // Get the address of the correct tab to show
    var office = _.find(offices, function(office) { return office.street === decodeURIComponent(location);});
    if(office) {
        return office.id;
    }
};

var renderOffices = function(baseLink, profile, resize) {
    var offices = allOffices;
    appendTemplateIfParentExists(
        '#our-offices',
        officeHtml,
        {
            baseLink: baseLink,
            offices: offices,
            currentPage: currentPage,
            officeStringHelper: officeStringHelper,
            directions: poly.ViewHelpers.googleMapsDirections,
            phoneFormat: poly.ViewHelpers.phoneFormat,
            zipFormat: poly.ViewHelpers.zipFormat,
            resize: resize
        }
    );

    // If we have a url parameter telling us which location to load, show that one.
    var location = queryParams.location || queryParams["?location"];
    if(location) {
        var officeId = getOfficeIdForLocationQuery(location, offices);
        if(officeId) {
            $('a[href="#' + officeId + '"]').tab('show');
        }
    }
};

var renderNewOffices = function() {
    appendTemplateIfParentExists(
        '#office-list-container',
        officeListTemplate,
        {
            offices: allOffices,
            resize: resize,
            zipFormat: poly.ViewHelpers.zipFormat,
            directions: poly.ViewHelpers.googleMapsDirections,
            phoneFormat: poly.ViewHelpers.phoneFormat,
            currentPage: currentPage,
            baseLink: baseLink
        }
    );
};

var addNewOfficesHandlers = function() {
    var $offices = $('.office');
    var seeMoreLinkTexts = {
        seeLess: 'See Less Info',
        seeMore: 'See More Info'
    };
    $offices.each(function() {
        var officeId = this.dataset.officeId;
        var officeSeeMoreLink = this.querySelector('.office__see-more-link');
        var officeDetailsContent = this.querySelector('.details__content');
        var officeTitle = this.querySelector('.office__title');
        officeSelectedIcons[officeId] = this.querySelector('.office__selected-icon');
        // setting up titles and
        officeTitle.addEventListener('click', function() {
            changeSelectedOffice(officeId);
        });

        // setting up see more links
        if ($offices.length === 1) {
            officeSeeMoreLink.isToggled = true;
            officeSeeMoreLink.innerHTML = seeMoreLinkTexts.seeLess;
            officeDetailsContent.style.display = 'block';
        } else {
            officeSeeMoreLink.isToggled = false;
            officeSeeMoreLink.innerHTML = seeMoreLinkTexts.seeMore;
        }
        officeSeeMoreLink.addEventListener('click', function(event) {
            event.preventDefault();
            officeSeeMoreLink.isToggled = !officeSeeMoreLink.isToggled;
            if (officeSeeMoreLink.isToggled) {
                officeSeeMoreLink.innerHTML = seeMoreLinkTexts.seeLess;
                officeDetailsContent.style.display = 'block';
                return;
            }
            officeSeeMoreLink.innerHTML = seeMoreLinkTexts.seeMore;
            officeDetailsContent.style.display = 'none';
        });
    });
};

window.setupMaps = function() {
    var isNewMap = $('#offices-map-container').length;
    if (isNewMap) {
        // show the redesigned office map too
        _.delay(function() { showNewMap(offices); }, 800);
    }
    if($('.google-map').length) {
        // Get the user's zipcode from their current location using the google geocoder, now that we know it's loaded.
        getUserLocation();

        var offices = allOffices;
        //If we have an active tab to show the map in on page load, show it; it doesn't fire an event
        var $initialPanel = $('.active.office-link').find('a').attr('href');
        if ($initialPanel) {
            // Delay initial map load. Without a delay, the map ends up getting
            // rendered before it's properly positioned (due to display:table and
            // slow image loads), so the marker ends up being incorrectly
            // positioned. Delay fixes this most of the time.
            _.delay(function() { show($initialPanel, profile, offices); }, 800);
        }

        // Event handler to show the map when a different tab is selected
        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            show(e.target.hash, profile, offices);
        });
    }
};

var renderAbout = function(baseLink, categories, profile, resize) {
    appendTemplateIfParentExists(
        '#team-members-container',
        aboutTeamHtml,
        {
            baseLink: baseLink,
            categories: categories,
            profile: profile,
            officeReference: officeReference,
            officeDescriptions: officeDescriptions,
            officeImages: officeImages,
            officeStreets: officeStreets,
            officeStringHelper: officeStringHelper,
            associatedOffices: associatedOffices,
            phoneFormat: poly.ViewHelpers.phoneFormat,
            resize: resize
        }
    );
};

var renderPosts = function(resize) {
    var allPosts = poly.JSContext.getPosts();
    if(_.isEmpty(allPosts) && !_.isEmpty(themeData.default_posts)) {
        _.each(themeData.default_posts, function(post, index) {
            post.id = index;
        });
        allPosts = themeData.default_posts;
    }

    appendTemplateIfParentExists(
        '#stories-articles-index',
        postsHtml,
        {
            posts: allPosts.slice(0, 3),
            groupSize: 3,
            resize: resize
        }
    );

    appendTemplateIfParentExists(
        '#stories-articles-main',
        postsHtml,
        {
            posts: allPosts,
            groupSize: 6,
            resize: resize
        }
    );

    $('.posts-show-more').click(function() {
        var $postId = $(this).data('id');
        var postToShow = _.find(allPosts, function(post) {
            return post.id === $postId;
        });

        $('body').addClass('lightbox-open');
        $('#body-wrapper').addClass('lightbox-open');

        appendTemplateIfParentExists(
            'body',
            lightboxHtml,
            {
                post: postToShow,
                resize: resize
            }
        );

        $('.lightbox-close').click(function() {
            $('body').removeClass('lightbox-open');
            $('#body-wrapper').removeClass('lightbox-open');

            $('.lightbox-wrapper').remove();
        });
    });

    $('.load-more-button').click(function() {
        var $rowToShow = $('.stories-articles .row:visible').last().next();
        $rowToShow.slideDown('fast');
        if ($rowToShow.is(':last-child')) {
            $(this).hide(0);
        }
        resizePostContentPreview();
        // ellipsify loaded posts too
        poly.ElementHelpers.ellipsify('.stories-articles .row:visible:last .ellipsify');
    });
};

var renderEvents = function(resize) {
    appendTemplateIfParentExists(
        '#events-index',
        eventsHtml,
        {
            events: poly.JSContext.getEvents({
                maxEvents: 1
            }),
            resize: resize,
            phoneFormat: poly.ViewHelpers.phoneFormat
        }
    );

    appendTemplateIfParentExists(
        '#events-main',
        eventsHtml,
        {
            events: poly.JSContext.getEvents(),
            resize: resize,
            phoneFormat: poly.ViewHelpers.phoneFormat
        }
    );
};

var getInsurance = function() {
    var insurance = themeData.insurance;
    var productsEqual = function(prod1, prod2) {
        return _.result(prod1.amfam_products, 0) === _.result(prod2.amfam_products, 0);
    };

    // Determine if any insurance types should be excluded. These must be explicitly requested.
    var explicitProducts = _.reject(["health", "travel"], function(ins) {
        return poly.Utils.selectBoxIsTrue(profile[ins + "_insurance"]);
    });

    // Filter the theme insurance list...
    insurance = _.reject(insurance, function(ins) {
        // ...of certain products that must be explicitly requested
        return _.contains(explicitProducts, ins.amfam_products[0]) ||
            // and products included in the profile's list of products
            _.find(profile.insurance, function(matcher) {
                return productsEqual(ins, matcher);
            });
    });

    // Now get the actual objects for the keys we have stored in the profile data
    // This uses the original theme insurance list because the agent may have chosen one of the excluded items.
    var getInsuranceObjectsForKeys = function() {
        return _.compact(_.map(profile.insurance, function(profileIns) {
            return _.find(themeData.insurance, function(themeIns) {
                return productsEqual(themeIns, profileIns);
            });
        }));
    };

    var profileInsurance = getInsuranceObjectsForKeys();

    return {profileInsurance: profileInsurance, insurance: insurance};
};

var renderInsurance = function(categories) {
    var insurance = getInsurance();

    appendTemplateIfParentExists(
        '#insurance',
        insuranceHtml,
        {
            categories: categories,
            insurance: insurance.profileInsurance.concat(insurance.insurance),
            baseLink: baseLink,
            includeViewAllButton: false
        }
    );
    appendTemplateIfParentExists(
        '#insurance--profile',
        insuranceHtml,
        {
            categories: categories,
            insurance: insurance.profileInsurance,
            baseLink: baseLink,
            includeViewAllButton: true
        }
    );
};

//In Your Community Content
var renderCommunity = function(communityInfo) {
    appendTemplateIfParentExists(
        '#community-index',
        communityHTML,
        {
            communityInfo: communityInfo
        }
    );
};

var renderEvergreenContent = function(profileExpertiseContent, themeExpertiseContent, expertiseTile) {

    // create two lists so that we can sort each to admins order before concat.
    profileExpertiseContent = profileExpertiseContent || [];
    themeExpertiseContent = themeExpertiseContent || [];
    var profileTiles = [];
    var themeTiles = [];

    // Create our selections based on the sorting of `expertiseTile` which admins ordered.
    var createTileLists = function(masterTileList, selectedList, resultList) {
        _.each(masterTileList, function(tile) {
            if (selectedList.indexOf(tile.ID) >= 0) {
                resultList.push(tile);
            }
        });
    };
    createTileLists(expertiseTile, profileExpertiseContent, profileTiles);
    createTileLists(expertiseTile, themeExpertiseContent, themeTiles);

    // check if we need defaults from `themeTiles` that are not in `profileTiles`
    var defaultsNeeded = 4 - profileTiles.length;
    var filteredThemetiles = _.filter(themeTiles, function(tile) {
        if (defaultsNeeded > 0) {
            return profileTiles.indexOf(tile) < 0;
        }
    });

    // combine our sorted lists, then groupBy for rows in `evergreen-content.html`
    var tiles = profileTiles.concat(filteredThemetiles);

    // splice off any extra defaults that were added - max 4 tiles.
    tiles.splice(4);
    var groupContent = _.groupBy(tiles || [], function(member, i) {
        return Math.floor(i / 2);
    });

    appendTemplateIfParentExists(
        '#evergreen-index',
        evergreenHtml, {
            themeData: themeData,
            groupContent: groupContent
        });
};

var $textConsentModal = $('.text-consent-modal');
var $textConsentModalOverlay = $('.text-consent-modal__background');
var $textConsentModalCloseButton = $textConsentModal.find('.text-consent-modal__close-button');
var $textConsentForm = $textConsentModal.find('.modal-form');
var $contactMethodDropdown = $('#contact-method');

$(document).ready(function() {
    // set the agentID cookie on site visit
    cookies.set("agentID", profile.gname, { expires: 730, domain: '.amfam.com' });

    setUpNav(baseLink, themeData);
    renderBioPhoto(profile, resize);
    renderBio(baseLink, themeData, profile);
    renderTeamPhoto(profile, resize);
    renderTeam(baseLink, themeData, profile);
    renderAbout(baseLink, categories, profile, resize);
    renderOffices(baseLink, profile, resize);
    renderNewOffices();
    addNewOfficesHandlers();
    renderPosts(resize);
    renderEvents(resize);
    renderInsurance(categories);
    renderLanguages(profile.amfam_languages);
    renderLicenses(profile.agent_licenses);
    renderAgencyRatings(profile.agency_rating);
    renderCommunity(communityInfo);
    renderEvergreenContent(profileExpertiseContent, themeExpertiseContent, expertiseTile);
    setRooftopPosition(false, parsedUrl);
    setNavDropdownPosition();
    addNavHandlers(parsedUrl);
    setupLinksWithGname();
    initWarningMessage();
    if (isRelateEnabled()) {
        $.get(getRelateOptinUrl(), function(relateData) {
            relatePhoneNumber = relateData.phone_number;
            relateAttestationText = relateData.attestation_text;
            relateConsentMessage = relateData.consent_message;
            if (!isRelateAvailable()) {
                return;
            }
            var $textContactOption = '<option value="text">Text</option>';
            $contactMethodDropdown.append($textContactOption);
            $('.modal-success__info').append(
                'You can contact '
                + profile.first_name
                + ' '
                + profile.last_name
                + ' via text message at '
                + relatePhoneNumber
                + '.'
            );
            setupTextConsentModal($textConsentModal, $textConsentModalOverlay, $textConsentModalCloseButton);
            setupTextConsentForm($textConsentForm);
        });
    }
    setTimeout(function() {
        resizePostContentPreview();
        poly.ElementHelpers.ellipsify('.ellipsify:visible');
    }, 0);
});

window.onload = function() {
    var path;
    if(baseLink !== '/') {
        path = virtualURLBaseLinkHelper(window.location, baseLink);
    } else {
        path = window.location.pathname;
    }
    var urlOfficeOrDefault = getOfficeFromURL(path);
    var urlPathOrDefault = getOfficePath(urlOfficeOrDefault);

    // check for static pages
    var page = _.intersection(staticPages, window.location.pathname.split('/'));

    // Exit early here if we have a non location aware page
    var nonLocationPage = _.intersection(page, nonLocationPages);
    if(nonLocationPage.length) {
        onLocationUnawarePageLoad();
        return;
    }

    // Grab the full path and remove any slashes
    var fullPath = window.location.pathname.split('/');
    if(fullPath[0] === "") { fullPath.shift(); }
    if(fullPath[fullPath.length - 1] === "") { fullPath.pop(); }

    // Grab the endpoint and remove any trailing slashes
    var endpoint = urlPathOrDefault.split('/');
    if(endpoint[0] === "") { endpoint.shift(); }
    if(endpoint[endpoint.length - 1] === "") { endpoint.pop(); }

    // If we have a valid partial path, we have a valid location page
    var partialPath = _.intersection(fullPath, endpoint);
    // Check for location aware page
    if(page[0] === "about-the-team" || page[0] === "contact-us" || partialPath.length) {
        onLocationAwarePageLoad(urlPathOrDefault);
    } else {
        onLocationUnawarePageLoad();
    }

    poly.Utils.loadGoogleMapsScript(JSContext.google_maps_key, "setupMaps");
};

$(window).scroll(function() {
    if ($(window).scrollTop() > 0) {
        $('header .top-bar').slideUp(150);
        $('header').addClass('scrolling');
    } else {
        $('header .top-bar').slideDown(150);
        $('header').removeClass('scrolling');
    }
});

$(window).resize(function() {
    resizePostContentPreview();
    poly.ElementHelpers.ellipsify('.ellipsify:visible');
    setRooftopPosition(false, parsedUrl);
    setNavDropdownPosition();
}).trigger('resize');

var changeLabels = function(el, addOrRemove) {
    if($(el).is('fieldset')) {
        $(el).find('legend')[addOrRemove]('invalid');
    } else {
        $('label[for="' + el.id + '"]')[addOrRemove]('invalid');
    }

    if($(el).is('select')) {
        var contactAuthorize = $('input.authorize-input').is(':checked') === true;
        var contactMethod = $('#contact-method').val();
        $(el).parent()[addOrRemove]('invalid');

        // Alternate checks for MS browsers
        if (browser && (browser.name === 'ie' || browser.name === 'edge')) {
            if (contactAuthorize) {
                $('#authorize-legend').removeClass('invalid');
            }

            if (contactMethod === '') {
                $('#preferred-contact-method').addClass('invalid');
            } else if (contactMethod === 'phone' || contactMethod === 'email') {
                $('#preferred-contact-method').removeClass('invalid');
            }
        }
    }
};

/// Contact form code
var validateLabelsForContactForm = function() {
    _.each(document.querySelectorAll('.contact-form :valid'), function(el) {
        changeLabels(el, 'removeClass');
    });

    _.each(document.querySelectorAll('.contact-form :invalid'), function(el) {
        changeLabels(el, 'addClass');
    });

    // Alternate fieldset element check for MS browsers
    if (browser && (browser.name === 'ie' || browser.name === 'edge')) {
        var pattern = /^\d{10}$/;
        var phoneNumber = $('#contact-area-code').val() + $('#contact-prefix').val() + $('#contact-number').val();
        var isPhoneNumber = pattern.test(phoneNumber);
        var contactMethod = $('#contact-method').val();
        var isContactPhone = contactMethod === 'phone' || contactMethod === 'text';
        var contactAuthorize = $('input.authorize-input').is(':checked') === true;

        !isPhoneNumber ? $('#phone-legend').addClass('invalid') : $('#phone-legend').removeClass('invalid');

        // Checks if phone & a call option have been selected
        if (isContactPhone && !contactAuthorize) {
            $('#authorize-legend').addClass('invalid');
        }
    }
};

var validateLabelsForTextConsentForm = function() {
    _.each(document.querySelectorAll('.modal-form :valid'), function(el) {
        $('label[for="' + el.id + '"]').removeClass('invalid');
    });
    _.each(document.querySelectorAll('.modal-form :invalid'), function(el) {
        $('label[for="' + el.id + '"]').addClass('invalid');
    });
};

$('.office-list.about-the-team').on('click', 'li a', function() {
    var selected = $('.office-container[data-office=' + $(this).attr('data-office') + ']');
    var current = $('.office-container.active');

    // Team office navigation / URL management
    var dataLocation = $(this).attr('data-location');
    var offices = allOffices;
    _.each(offices, function(office) { office.street = officeStringHelper(office.street); });
    // Find an office by it's street name
    var office = _.findWhere(offices, {'street': dataLocation });
    var officePath = getOfficePath(office);
    onLocationSelected(officePath);

    current.addClass('hidden').removeClass('active');
    selected.removeClass('hidden').addClass('active');
});

$('.tab-nav.contact-us').on('click', 'li a', function() {
    // Team office navigation / URL management
    var dataLocation = $(this).attr('data-location');

    // Find an office by it's street name
    var offices = allOffices;
    _.each(offices, function(office) { office.street = officeStringHelper(office.street); });

    var office = _.findWhere(offices, {'street': dataLocation });

    var officePath = getOfficePath(office);
    onLocationSelected(officePath);
});

// enforce API constraints on the contact method
$('#contact-method').on('change', function(e) {
    var isPhone = e.target.value === 'phone';
    // var isEmail = e.target.value === 'email';
    // isPhone ? $('#phone-legend').addClass('required') : $('#phone-legend').removeClass('required');
    isPhone ? $('#authorize-legend').addClass('required') : $('#authorize-legend').removeClass('required');
    // $('#contact-area-code').attr('required', isPhone);
    // $('#contact-prefix').attr('required', isPhone);
    // $('#contact-number').attr('required', isPhone);
    $('input.authorize-input').attr('required', isPhone);

    // isEmail ? $('#email-label').addClass('required') : $('#email-label').removeClass('required');
    // $('#contact-email').attr('required', isEmail);

    if ($(this).val() === 'email') {
        $('#email-label').addClass('required');
        $('#contact-email').attr('required', 'required');
    } else {
        $('#email-label').removeClass('required');
        $('#contact-email').removeAttr('required');
    }

    validateLabelsForContactForm();
});
var $formElement = $('.contact-form');
var $allInputs = $formElement.find('input, select, textarea');
// Very closely modeled after the poly-js-utils code.
$('#contact-form-submit').on('click', function(e) {
    $('#contact-success').hide();
    var isValid = function() {
        var requiredText = $('.section-header .contact-text--disclaimer');
        var endErrorMessage = $('.error-message-alert');
        validateLabelsForContactForm();
        requiredText.removeClass('invalid');
        endErrorMessage.addClass('hidden');
        endErrorMessage.text("");

        $formElement.addClass("validated");

        var isAuthorizedCall = $('input[name=authorize]:checked').val();
        var preferredMethod = $('#contact-method').val();

        if ($formElement.length < 1 || !$formElement[0].checkValidity() ||
        (isAuthorizedCall === "No" && preferredMethod === "phone")) {
            validateLabelsForContactForm();
            var invalidElements = document.querySelectorAll('.contact-form :invalid');

            var validityReasons = {};
            _.each(invalidElements, function(el) {
                // Keys are field labels. Values are reasons that the field failed validation.
                var label = $('label[for="' + el.id + '"]').text().trim();
                validityReasons[label] = _.keys(_.pick(el.validity, _.identity))[0];
            });
            var otherReasons = _.omit(validityReasons, function(value) {
                return value === "valid";
            });

            var messages = {
                "First Name": {
                    class: ".error-first-name",
                    valueMissingMessage: "First Name is required."
                },
                "Last Name": {
                    class: ".error-last-name",
                    valueMissingMessage: "Last Name is required."
                },
                "Address": {
                    class: ".error-street",
                    valueMissingMessage: "Address is required."
                },
                "City": {
                    class: ".error-city",
                    valueMissingMessage: "City is required.",
                    invalidValueMessage: "City is not valid."
                },
                "State": {
                    class: ".error-state",
                    valueMissingMessage: "State is required."
                },
                "ZIP Code": {
                    class: ".error-zip",
                    valueMissingMessage: "ZIP Code should be 5 digits."
                },
                "Preferred Method of Contact": {
                    class: ".error-preferred-method",
                    valueMissingMessage: "Preferred Method of Contact is required."
                },
                "Email": {
                    class: ".error-email",
                    valueMissingMessage: "Email is required.",
                    invalidValueMessage: "Email is not valid."
                },
                "Area Code": {
                    class: ".error-phone",
                    valueMissingMessage: "Phone should be 10 digits.",
                    invalidValueMessage: "Phone is not valid."
                },
                "Prefix (the three digits after the area code)": {
                    class: ".error-phone",
                    valueMissingMessage: "Phone should be 10 digits.",
                    invalidValueMessage: "Phone is not valid."
                },
                "Number (last four digits)": {
                    class: ".error-phone",
                    valueMissingMessage: "Phone should be 10 digits.",
                    invalidValueMessage: "Phone is not valid."
                }

            };
            _.each(_.keys(otherReasons), function(key) {
                if (messages[key]) {
                    if (otherReasons[key] === "valueMissing") {
                        $(messages[key].class + '.error-message-alert').text(messages[key].valueMissingMessage);
                    }
                    if (otherReasons[key] === "typeMismatch" || otherReasons[key] === "patternMismatch") {
                        $(messages[key].class + '.error-message-alert').text(messages[key].invalidValueMessage);
                    }
                    requiredText.addClass('invalid');
                    endErrorMessage.removeClass('hidden');
                }
            });
            if (!endErrorMessage.hasClass('hidden')) {
                var invalidElement = $('.invalid')[1];

                $('html, body').animate({
                    scrollTop: $(invalidElement).offset().top
                }, 150);
            }
            return false;
        } else {
            return true;
        }
    };

    e.preventDefault();
    $allInputs.on('change', validateLabelsForContactForm);

    if (isValid()) {
        $allInputs.off('change', validateLabelsForContactForm);
    }
    return false;
});
var setContactFormDigitalData = function() {
    var pageNameTemplate = `FieldForce:Agent:${profile.first_name} ${profile.last_name}:ContactMe:MessageSent`;
    if (window.digitalData) {
        window.digitalData.page.pageInfo.pageName = pageNameTemplate;
    }
    window._satellite && window._satellite.track('agentsitecontact');
};
const renderTrackingPixel = (id) => {
    if (id) {
        const trackingUrl = `https://www.nextinsure.com/ListingDisplay/Outcome/?O=${id}`;
        const trackingPixel = document.createElement('img');
        trackingPixel.width = '1';
        trackingPixel.height = '1';
        trackingPixel.style = 'border-style: none;';
        trackingPixel.alt = '';
        trackingPixel.src = trackingUrl;

        const trackingPixelContainer = document.getElementById('tracking-pixels');
        trackingPixelContainer.appendChild(trackingPixel);
    }
};
const renderSuccess = () => {
    var textConsentFormPrefillData = getTextConsentFormPrefillData($formElement);
    showTextConsentModal($textConsentModal, $textConsentModalOverlay);
    fillTextConsentForm($textConsentForm, textConsentFormPrefillData);
    setContactFormDigitalData();
    $allInputs.val('');
    $('select').parent().addClass('select');
    $('#contact-success').show();
    // remove html5 validation errors, if any
    $formElement.removeClass('validated');
    $('input[name=authorize]').attr('checked', false);
    //track form submit
    renderTrackingPixel(themeData.sales_pixel_id);
    renderTrackingPixel(themeData.quote_pixel_id);
};

var contactformOptions = {
    onSuccess: renderSuccess,
    customProcessor: function(postParams) {
        postParams.name = $("#contact-first-name").val() + ' ' + $("#contact-last-name").val();
        postParams.phone = $("#contact-area-code").val() +
                           $("#contact-prefix").val() +
                           $("#contact-number").val();
        return postParams;
    }
};

const QUERY_OBJECT = {tid: 'AgentContactFormSubmit'};

// Activate the contact form, pass in the email input pattern attribute to use this forms pattern.
poly.ContactForm.activate(poly.JSContext.getOrgLink(),
                            poly.JSContext.getSlug(),
                            contactformOptions,
                            $('input[name="email"]').attr('pattern'),
                            QUERY_OBJECT);

/// Offices map
var show = function(el, profile, offices) {
    var loadMapDependingOnSize = function(latlng, container) {
        $(window).resize(function() {
            var gMap;
            if($(window).width() > 767) {
                gMap = poly.MapTools.showGoogleMap(latlng, container.id);
            } else {
                gMap = poly.MapTools.showStaticGoogleMap(latlng, container.id);
            }
                // If there are multiple offices to be shown on this map, add them to the map
            if(offices.length > 1) {
                // We will need to reset the bounds of the map to include the multiple pins
                var bounds = new google.maps.LatLngBounds();
                _.each(offices, function(office) {
                    if(office.latlng && office.latlng[0] && office.latlng[1]) { // guard against positions that couldn't be geocoded
                        var position = {lat: office.latlng[0], lng: office.latlng[1]};
                        // original latlng has to be explicitly added to the bounds too.
                        bounds.extend(position);
                        // Only add pins for offices that aren't the original office
                        if(position.lat !== latlng[0] && position.lng !== latlng[1]) {
                            var otherOfficeImage = {
                                url: otherOfficePin,
                                scaledSize: new google.maps.Size(19, 19)
                            };
                            var marker = new google.maps.Marker({
                                map: gMap,
                                position: position,
                                icon: otherOfficeImage,
                                optimized: false
                            });
                            marker.addListener('click', function() {
                                $('a[href="#' + office.id + '"]').tab('show');
                                var dataLocation = $('a[href="#' + office.id + '"]').attr('data-location');

                                // Find an office by it's street name and set the url location
                                var offices = allOffices;
                                _.each(offices, function(office) {
                                    office.street = officeStringHelper(office.street);
                                });
                                var location = _.findWhere(offices, {'street': dataLocation });
                                var officePath = getOfficePath(location);
                                onLocationSelected(officePath);
                            });
                        }
                    }
                });
                gMap.fitBounds(bounds);
            }
        }).trigger('resize');
    };
    var container = $(el).find('.google-map')[0];

    // We need to explicitly set the height property (css) of the map
    // container, which will need to be reset on resizes as well.
    var $img = $(el).find('.office-image>img');
    $(window).resize(function() {
        $(container).css('height', $img.height());
    }).trigger('resize');

    var latlng = $(el).find('.address-text').data('latlng');
    if (latlng) {
        latlng = latlng.split(',').map(parseFloat);
        loadMapDependingOnSize(latlng, container);
    } else {
        var address = $(el).find('.address-text').text().trim();
        poly.MapTools.googleGeocodeAddress(address, function(location) {
            latlng = location;
            loadMapDependingOnSize(location, container);
        });
    }
};

function setupMarkers(gMap, latLngBounds, officeCoordinates, markerCoordinates) {
    _.each(officeCoordinates, (officeCoordinate) => {
        var officeId = officeCoordinate.id;
        if (officeId === selectedOfficeId) {
            officeSelectedIcons[officeId].style.display = 'inline';
        } else {
            officeSelectedIcons[officeId].style.display = 'none';
        }
    });
    _.each(officeMarkers, function(oldMarker) {
        oldMarker.setMap(null);
    });
    _.each(markerCoordinates, function(markerCoordinate) {
        var officeId = markerCoordinate.id;
        var currentMarkerIcon = officeId !== selectedOfficeId
            ? nonSelectedMarkerIcon
            : selectedMarkerIcon;
        var currentMarkerPosition = {
            lat: markerCoordinate.lat,
            lng: markerCoordinate.lng
        };
        latLngBounds.extend(currentMarkerPosition);
        var currentMarker = new google.maps.Marker({
            map: gMap,
            position: currentMarkerPosition,
            icon: currentMarkerIcon,
            optimized: false
        });
        currentMarker.addListener('click', function() {
            changeSelectedOffice(officeId);
        });
        officeMarkers[officeId] = currentMarker;
    });
}
function changeSelectedOffice(officeId) {
    selectedOfficeId = officeId;
    var currentMarker = officeMarkers[officeId];
    var selectedOffice = _.findWhere(allOffices, { id: officeId });
    var selectedOfficePath = getOfficePath(selectedOffice);
    _.each(officeMarkers, function(otherMarker) {
        otherMarker.setIcon(nonSelectedMarkerIcon);
    });
    if (currentMarker) {
        currentMarker.setIcon(selectedMarkerIcon);
    }
    _.each(officeSelectedIcons, function(officeSelectedIcon) {
        officeSelectedIcon.style.display = 'none';
    });
    if (!selectedOffice.virtual_location) {
        officeSelectedIcons[officeId].style.display = 'inline';
    }
    onLocationSelected(selectedOfficePath);
}
function loadNewMapDependingOnSize(allOfficeCoordinates, shownOfficeCoordinates, $mapContiner) {
    var mapContinerId = $mapContiner.attr('id');
    $(window).resize(function() {
        var gMap = poly.MapTools.showGoogleMap(undefined, mapContinerId);
        var latLngBounds = new google.maps.LatLngBounds();
        setupMarkers(gMap, latLngBounds, allOfficeCoordinates, shownOfficeCoordinates);
        gMap.fitBounds(latLngBounds);
        if (shownOfficeCoordinates.length === 1) {
            var zoomListener = google.maps.event.addListener(gMap, "idle", () => {
                if (gMap.getZoom() > 17) {
                    gMap.setZoom(17);
                }
                google.maps.event.removeListener(zoomListener);
            });
        }
    }).trigger('resize');
}
function getOfficeAddress(office) {
    const {
        street, suite, city, state, zip_code
    } = office;
    return [
        street,
        suite ? ' ' : '', suite,
        ', ', city,
        ', ', state,
        ' ', poly.ViewHelpers.zipFormat(zip_code, true)
    ].filter(addressPart => !!addressPart).join('');
}
function getOfficeCoordinate(office) {
    var officeLatLng = office.latlng;
    if (officeLatLng) {
        return {
            lat: officeLatLng[0],
            lng: officeLatLng[1],
            id: office.id
        };
    }
    return {
        id: office.id
    };
}
function setContainerHeights($mapContainer, $officeListContainer) {
    var $window = $(window);
    var $offices = $('#office-list-container .office');
    var minContainerHeight = 400;
    var maxOfficeCountForHeight = 3;
    // TODO can we pull in this breakpoint from bootstrap?
    var cssBreakpoint = 992;
    var verticalPaddings = 30;
    $window.resize(function() {
        if ($window.width() < cssBreakpoint) {
            $mapContainer.css('height', minContainerHeight);
            $officeListContainer.css('height', 'auto');
            $officeListContainer.css('overflow-x', 'visible');
            $officeListContainer.css('overflow-y', 'visible');
            return;
        }
        var officeHeights = 2; // start with 2px, solid border
        $offices.each(function(officeIndex) {
            if (officeIndex < maxOfficeCountForHeight) {
                officeHeights += $(this).height();
            }
        });
        var maxContainerHeight = officeHeights;
        var containerHeight = Math.max(minContainerHeight, maxContainerHeight);
        $mapContainer.css('height', containerHeight - verticalPaddings);
        $officeListContainer.css('height', containerHeight);
        $officeListContainer.css('overflow-y', 'auto');
        $officeListContainer.css('overflow-x', 'hidden');
    }).trigger('resize');
}
function showNewMap(offices) {
    var $mapContainer = $('#offices-map-container');
    var $officeListContainer = $('#office-list-container');
    var $previewErrorBanner = $('.preview-error-banner');
    var $previewErrorBannerAddresses = $('.preview-error-banner__addresses');
    nonSelectedMarkerIcon = {
        url: otherOfficePin,
        scaledSize: new google.maps.Size(19, 19)
    };
    selectedMarkerIcon = {
        url: googleMapsPin,
        scaledSize: new google.maps.Size(38, 38)
    };
    const nonGeocodedOfficeAddressDivs = offices
        .filter(({ latlng }) => !latlng || !latlng.length)
        .map(office => `<div>${getOfficeAddress(office)}</div>`);
    if (nonGeocodedOfficeAddressDivs.length && isPreview) {
        $previewErrorBannerAddresses.html(nonGeocodedOfficeAddressDivs);
        $previewErrorBanner.show();
    }
    const allOfficeCoordinates = offices
        .filter(({ virtual_location }) => !virtual_location)
        .map((office) => getOfficeCoordinate(office));
    setContainerHeights($mapContainer, $officeListContainer);
    const shownOfficeCoordinates = allOfficeCoordinates.filter(({ lat }) => !!lat);
    loadNewMapDependingOnSize(allOfficeCoordinates, shownOfficeCoordinates, $mapContainer);
}

function appendGnameToUrl(url) {
    var isUrlLacksGname = url.indexOf('gname') < 0;
    var isUrlLacksQueryString = url.indexOf('?') < 0;
    var gname = profile.gname;
    if (!gname || !isUrlLacksGname) {
        return url;
    }
    if (isUrlLacksQueryString) {
        return url + '?gname=' + gname;
    }
    return url + '&gname=' + gname;
}

function setupLinksWithGname() {
    $('[data-gname-link]').each(function() {
        var $link = $(this);
        var linkHref = $link.attr('href');
        $link.attr('href', appendGnameToUrl(linkHref));
    });
}

function setupTextConsentModal($textConsentModal, $textConsentModalOverlay, $textConsentModalCloseButton) {
    var $focusableElements = $textConsentModal.find(''
        + 'a[href], '
        + 'area[href], '
        + 'input:not([disabled]), '
        + 'select:not([disabled]), '
        + 'textarea:not([disabled]), '
        + 'button:not([disabled]), '
        + '[tabindex="0"]'
    );
    $textConsentModal.$focusableElements = $focusableElements;
    $textConsentModal.firstFocusableEl = $focusableElements.get(0);
    $textConsentModal.lastFocusableEl = $focusableElements.get($focusableElements.length - 1);
    $textConsentModalCloseButton.on('click', function() {
        $textConsentModal.hide();
        $textConsentModalOverlay.hide();
        var focusedElBeforeOpen = $textConsentModal.focusedElBeforeOpen;
        if (focusedElBeforeOpen) {
            focusedElBeforeOpen.focus();
        }
    });
    $textConsentModal.keydown(function(event) {
        function handleBackwardTab() {
            if (document.activeElement === $textConsentModal.firstFocusableEl) {
                event.preventDefault();
                $textConsentModal.lastFocusableEl.focus();
            }
        }
        function handleForwardTab() {
            if (document.activeElement === $textConsentModal.lastFocusableEl) {
                event.preventDefault();
                $textConsentModal.firstFocusableEl.focus();
            }
        }
        switch(event.keyCode) {
            case KEY_TAB:
                if ($textConsentModal.$focusableElements.length === 1) {
                    event.preventDefault();
                    break;
                }
                if (event.shiftKey) {
                    handleBackwardTab();
                } else {
                    handleForwardTab();
                }
                break;
            case KEY_ESC:
                $textConsentModal.hide();
                $textConsentModalOverlay.hide();
                break;
            default:
                break;
        }
    });
}

function showTextConsentModal($textConsentModal, $textConsentModalOverlay) {
    if ($('#contact-method').val() !== 'text') {
        return;
    }
    var $modalSuccess = $('.modal-success');
    var $modalBodyHeader = $('.text-consent-modal__body-header');
    var $modalFormWrapper = $('.text-consent-modal__form-wrapper');
    var $endErrorMessage = $('.modal-form__error');
    $textConsentModal.focusedElBeforeOpen = document.activeElement;
    setTimeout(() => {
        $endErrorMessage.addClass('hidden');
        $endErrorMessage.text('');
        $modalSuccess.hide();
        $modalBodyHeader.show();
        $modalFormWrapper.show();
        $textConsentModal.fadeIn(300);
        $textConsentModalOverlay.fadeIn(300);
        $([document.documentElement, document.body]).animate({
            scrollTop: $textConsentModal.offset().top
        }, 300);
        $textConsentModal.firstFocusableEl.focus();
    }, 300);
}

function setupTextConsentForm($textConsentForm) {
    var $modalSuccess = $('.modal-success');
    // TODO create a modal error screen!
    var $modalError = $('.modal-error');
    var $modalBodyHeader = $('.text-consent-modal__body-header');
    var $modalFormWrapper = $('.text-consent-modal__form-wrapper');
    var $textConsentFormInputs = $textConsentForm.find('input');
    var $endErrorMessage = $('.modal-form__error');
    var errorMessages = {
        'firstName': {
            class: '.modal-form__error--first-name',
            valueMissingMessage: 'First Name is required.'
        },
        'lastName': {
            class: '.modal-form__error--last-name',
            valueMissingMessage: 'Last Name is required.'
        },
        'email': {
            class: '.modal-form__error--email',
            valueMissingMessage: 'Email is required.',
            invalidValueMessage: 'Email is not valid.'
        },
        'phoneNumber': {
            class: '.modal-form__error--phone-number',
            valueMissingMessage: 'Phone should be 10 digits.',
            invalidValueMessage: 'Phone is not valid.'
        },
        'consent': {
            class: '.modal-form__error--consent',
            valueMissingMessage: 'Consent is required.'
        }
    };
    $('.modal-form__signup').on('click', function(e) {
        var resetForm = function() {
            validateLabelsForTextConsentForm();
            $endErrorMessage.addClass('hidden');
            $endErrorMessage.text('');
            $modalSuccess.hide();
            $modalBodyHeader.show();
            $modalFormWrapper.show();
        };
        var getInvalidityReasons = function(invalidElements) {
            var validityReasons = {};
            _.each(invalidElements, function(invalidElement) {
                var elementName = invalidElement.name;
                validityReasons[elementName] = _.keys(_.pick(invalidElement.validity, _.identity))[0];
            });
            return _.omit(validityReasons, function(value) {
                return value === 'valid';
            });
        };
        var showErrorMessages = function(invalidityReasons) {
            _.each(_.keys(invalidityReasons), function(key) {
                if (!errorMessages[key]) {
                    return;
                }
                if (invalidityReasons[key] === "valueMissing") {
                    $(errorMessages[key].class + '.modal-form__error')
                        .text(errorMessages[key].valueMissingMessage);
                }
                if (
                    invalidityReasons[key] === "typeMismatch"
                    || invalidityReasons[key] === "patternMismatch"
                ) {
                    $(errorMessages[key].class + '.modal-form__error')
                        .text(errorMessages[key].invalidValueMessage);
                }
                $endErrorMessage.removeClass('hidden');
            });
        };
        var scrollToFirstInvalidMessage = function() {
            if ($endErrorMessage.hasClass('hidden')) {
                return;
            }
            var invalidElement = $('.invalid')[1];
            $('html, body').animate({
                scrollTop: $(invalidElement).offset().top
            }, 150);
        };
        var isValid = function() {
            resetForm();
            $textConsentForm.addClass('validated');
            var isFormNotPresent = $textConsentForm.length < 1 || !$formElement[0].checkValidity();
            if (!isFormNotPresent) {
                return true;
            }
            validateLabelsForTextConsentForm();
            var invalidElements = document.querySelectorAll('.modal-form :invalid');
            var invalidityReasons = getInvalidityReasons(invalidElements);
            if (!Object.keys(invalidityReasons).length) {
                return true;
            }
            showErrorMessages(invalidityReasons);
            scrollToFirstInvalidMessage();
            return false;
        };

        e.preventDefault();
        $textConsentFormInputs.on('change', validateLabelsForTextConsentForm);

        if (isValid()) {
            var postData = getPostDataForRelateOptin($textConsentForm);
            var relateOptinUrl = getRelateOptinUrl();
            $.ajax({
                url: relateOptinUrl,
                data: JSON.stringify(postData),
                cache: false,
                dataType: 'json',
                traditional: true,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                success: function(response) {
                    var error = response.error;
                    if (error) {
                        // TODO discuss message?
                        $modalError.append('Error: ' + error);
                        $modalError.show();
                        return;
                    }
                    $textConsentFormInputs.off('change', validateLabelsForTextConsentForm);
                    $modalBodyHeader.hide();
                    $modalFormWrapper.hide();
                    $modalSuccess.show();
                },
                error: function() {
                    // TODO discuss message?
                    $modalError.show('An error occured. Please try again.');
                },
                complete: function() {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $textConsentModal.offset().top
                    }, 300);
                }
            });
        }
        return false;
    });
}

function getPostDataForRelateOptin($textConsentForm) {
    var firstName = $textConsentForm.find('#modal-form-first-name').val();
    var lastName = $textConsentForm.find('#modal-form-last-name').val();
    var phoneNumber = $textConsentForm.find('#modal-form-phone-number').val();
    var email = $textConsentForm.find('#modal-form-email').val();
    return {
        consent_message: relateConsentMessage,
        attestation_text: relateAttestationText,
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber,
        email_address: email
    };
}

function getRelateOptinUrl() {
    return JSContext.org_link + 'api/relate-optin/' + groupId + '/';
}

function fillTextConsentForm($textConsentForm, formData) {
    const {
        firstName,
        lastName,
        email,
        phoneNumber
    } = formData;
    $textConsentForm.find('#modal-form-first-name').val(firstName);
    $textConsentForm.find('#modal-form-last-name').val(lastName);
    $textConsentForm.find('#modal-form-phone-number').val(phoneNumber);
    $textConsentForm.find('#modal-form-email').val(email);
}

function getTextConsentFormPrefillData($contactForm) {
    const firstName = $contactForm.find('#contact-first-name').val();
    const lastName = $contactForm.find('#contact-last-name').val();
    const email = $contactForm.find('#contact-email').val();
    const prefix = $contactForm.find('#contact-prefix').val();
    const areaCode = $contactForm.find('#contact-area-code').val();
    const number = $contactForm.find('#contact-number').val();
    const phoneNumber = '(' + areaCode + ') ' + prefix + '-' + number;
    return {
        firstName,
        lastName,
        email,
        phoneNumber
    };
}

function isRelateEnabled() {
    return JSContext.theme_data.is_text_consent_enabled &&
        JSContext.theme_data.is_text_consent_enabled[0] === 'true';
}

function isRelateAvailable() {
    return relatePhoneNumber && isRelateEnabled();
}

const initWarningMessage = () => {
    const { warning_message_canonical_name, warning_message_enabled } = JSContext.theme_data.warning_msg_options || {};

    const warningMsgEnabled = poly.Utils.selectBoxIsTrue(warning_message_enabled);
    const warningMsgCookieKey = 'warning_msg_' + warning_message_canonical_name;

    if (warningMsgEnabled && !localStorage.getItem(warningMsgCookieKey)) {
        showWarningMessage(warningMsgCookieKey);
    }
};

const showWarningMessage = warningMsgCookieKey => {
    const warningMsgContainer = document.querySelector('.warning-message');
    const body = document.querySelector('body');

    const telHref = document.querySelector('.warning-message__tel');
    if (telHref) {
        const formattedPhone = poly.ViewHelpers.phoneFormat(profile.phones.phone || '', true);
        telHref.text = formattedPhone;
    }

    warningMsgContainer.classList.remove('hidden');
    body.classList.add('warning-message--open');

    const closeButton = document.querySelector('.warning-message__close-button');
    closeButton.addEventListener('click', () => {
        warningMsgContainer.classList.add('hidden');
        body.classList.remove('warning-message--open');
        localStorage.setItem(warningMsgCookieKey, 'true');
    });
};



// WEBPACK FOOTER //
// ./js/script.js